import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import GenericPromises from '../../../../../api/GenericPromises';
import { FormsErrors } from '../../../../../hooks/Forms/FormsErrors';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { Header } from '../../../../../components/Header';
import { Button, TextField } from '@mui/material';
import { ButtonStyled, PrimaryButton } from '../../../../../theme/buttons';
import { DriverType } from '../../../../../interfaces/Sales/Catalogs/TransportationDocuments/driverTypes';
import useSnackBar from '../../../../../components/Commons/SnackBar/useSnackBar';

export const AddDriverTypes = () => {
    const [t] = useTranslation("global");
    const navigate = useNavigate();
    const { GenericPostResource, GenericGetResourceGeneric } = GenericPromises();
    const { showSnackBar, SnackbarComponent } = useSnackBar();
    const { GetError } = FormsErrors();
    const [loadingPost, setLoadingPost] = useState(false);

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<DriverType>({
        defaultValues: {
            driver_type_code: '',
            driver_type_name: '',
        }
    });
    const onSubmit: SubmitHandler<DriverType> = (data) => onPost(data);

    const onPost = (data: DriverType) => {
        let myData = {
            driver_type_code: data.driver_type_code,
            driver_type_name: data.driver_type_name,
        }
        setLoadingPost(true);
        GenericPostResource("/drivertypes", myData)
            .then((response) => {
                navigate("/drivertypes", { state: { method: "add" } });
            })
            .catch((error) => {
                setLoadingPost(false);
                showSnackBar(error.message, 'error');
            });
    }

    const onCancel = () => {
        // validacion si quiere cancelar sus cambios 
        navigate("/drivertypes", { state: {} });
    }
    
    useEffect(()=>{
        GenericGetResourceGeneric("/companies", "/gcompanies").then((response) => {
            document.title = `${response.data.data[0].comercial_name} - ${t("drivertypes.title")}`;
        })
    },[])

    return (
        <>
            <Header title={t("drivertypes.title-view")} />
            <div className='d-flex justify-content-center'>

                <div className='custom-card-view w-75'>

                    <form onSubmit={handleSubmit(onSubmit)} className='mt-4'>

                        <div className="custom-card-row d-flex justify-content-between">
                            <div className="w-100">
                                <div className='d-flex w-100'>
                                    <div className='w-50'>
                                        <Controller
                                            name="driver_type_code"
                                            control={control}
                                            rules={{ required: true, maxLength: 10 }}
                                            render={({ field }) =>
                                                <TextField
                                                    variant="filled"
                                                    label={`${t("drivertypes.fields.driver_type_code")}`}
                                                    ref={field.ref}
                                                    value={field.value}
                                                    onChange={(event) => { field.onChange(event.target.value) }}
                                                    error={!!errors.driver_type_code}
                                                    helperText={GetError(errors.driver_type_code?.type)}
                                                    size="small"
                                                    style={{ width: "100%" }}
                                                    sx={{ paddingRight: 2 }}
                                                />
                                            }
                                        />
                                    </div>
                                    <div className='w-50'>
                                        <Controller
                                            name="driver_type_name"
                                            control={control}
                                            rules={{ required: true,maxLength: 150 }}
                                            render={({ field }) =>
                                                <TextField
                                                    variant="filled"
                                                    label={`${t("drivertypes.fields.driver_type_name")}`}
                                                    ref={field.ref}
                                                    value={field.value}
                                                    onChange={(event) => { field.onChange(event.target.value) }}
                                                    error={!!errors.driver_type_name}
                                                    helperText={GetError(errors.driver_type_name?.type)}
                                                    size="small"
                                                    style={{ width: "100%" }}
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                </div>

                <div className='d-flex flex-row-reverse mt-1'>
                    <PrimaryButton type='submit' variant='outlined' className='m-1' disabled={loadingPost}>{t("generic.buttons.accept")}</PrimaryButton>
                    <ButtonStyled variant='contained' className='m-1' onClick={onCancel}>{t("generic.buttons.cancel")}</ButtonStyled>
                </div>

            </form>

        </div >

      </div >
    <SnackbarComponent />
    </>
  )
}
